import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* HEADER */}
      <header className="fixed top-0 w-full z-50 backdrop-blur-md bg-white/90 border-b border-black/5">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between relative">

          {/* Hamburger (mobile) */}
          <button
            className="md:hidden text-2xl"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            ☰
          </button>

          {/* LOGO */}
          <div className="absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0 flex items-center">
            <a href="/" aria-label="Kaali Global Home">
              <img
                src="/assets/logo.png"
                alt="Kaali Global - Premium Indian Spices Exporter"
                className="h-10 md:h-12 object-contain"
              />
            </a>
          </div>

          {/* Desktop Menu */}
          <nav className="hidden md:flex gap-8 text-sm tracking-wide">
            <a href="#products" className="hover:text-[#0a7d4f] transition">
              Products
            </a>
            <a href="#story" className="hover:text-[#0a7d4f] transition">
              Our Story
            </a>
            <a href="#contact" className="hover:text-[#0a7d4f] transition">
              Contact
            </a>
          </nav>

          {/* Desktop CTA */}
          <a
            href="#contact"
            className="hidden md:block border border-[#0a7d4f] text-[#0a7d4f] px-6 py-2 text-xs uppercase rounded-full hover:bg-[#0a7d4f] hover:text-white transition"
          >
            Enquire
          </a>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div
        className={`fixed inset-0 z-50 bg-white transform transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="flex items-center justify-between px-6 h-16 border-b">
          <img
            src="/assets/logo.png"
            alt="Kaali Global Logo"
            className="h-9"
          />
          <button
            className="text-2xl"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <nav className="flex flex-col gap-8 px-8 py-16 text-xl font-serif">
          <a href="#products" onClick={() => setOpen(false)}>
            Products
          </a>
          <a href="#story" onClick={() => setOpen(false)}>
            Our Story
          </a>
          <a href="#contact" onClick={() => setOpen(false)}>
            Contact
          </a>

          {/* Mobile CTA */}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-10 inline-block text-center bg-[#0a7d4f] text-white py-4 rounded-full text-sm uppercase tracking-wide"
          >
            Enquire on WhatsApp
          </a>
        </nav>
      </div>
    </>
  );
}
